var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var Download = function (props) { return (React.createElement("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.8332 9.94434V12.5369C13.8332 12.8807 13.6966 13.2104 13.4535 13.4535C13.2104 13.6967 12.8807 13.8332 12.5369 13.8332H3.4628C3.119 13.8332 2.78928 13.6967 2.54618 13.4535C2.30308 13.2104 2.1665 12.8807 2.1665 12.5369V9.94434", stroke: "#443EFF", strokeWidth: "1.2963", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.75928 6.70361L8.00002 9.94435L11.2408 6.70361", stroke: "#443EFF", strokeWidth: "1.2963", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8 9.9444V2.16663", stroke: "#443EFF", strokeWidth: "1.2963", strokeLinecap: "round", strokeLinejoin: "round" }))); };
export default Download;
//# sourceMappingURL=Download.js.map